import { render } from "./AddNoteItemModal.vue?vue&type=template&id=5863186c"
import script from "./AddNoteItemModal.vue?vue&type=script&lang=js"
export * from "./AddNoteItemModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__